import { useTranslation } from 'react-i18next';
import { useRecoveryService } from 'app/utils/services/recoveryService';
import { useLocation } from 'react-router-dom';

const useEmailSent = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const data = location.state;

  const { isLoadingRecovery, dataRecovery, recoveryMutation } = useRecoveryService();

  const handleResend = () => {
    recoveryMutation({ data: { form_id: 'resend' }, url: `${data?.path_url}?business_key=${data?.business_key}` });
  };

  return { t, handleResend };
};

export default useEmailSent;
